import React from "react";
import Navbar from "../component/common/Navbar";

const Terms = () => {
  return (
    <>
      <Navbar />

      <div
        style={{ background: "#000", color: "#ffffff", paddingTop: 120 }}
        className="p-6 md:p-10 bg-gray-100 text-gray-900"
      >
        <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>
        <p className="mb-4">
          Welcome to PlayGG! By accessing or using our website (playgg.in), you
          agree to comply with and be bound by the following Terms and
          Conditions. These terms govern your use of our services, including
          participating in tournaments and booking gaming cafes.
        </p>
        <p className="mb-4">
          Please read these Terms and Conditions carefully. If you do not agree
          with any part of these terms, you must not use our platform. By
          continuing to use our website, you acknowledge that you have read,
          understood, and agreed to these terms in their entirety.
        </p>
        <p className="mb-4">
          Our goal is to create a fair, fun, and engaging gaming environment for
          all users. We encourage you to review these terms regularly, as we may
          update them from time to time.
        </p>
        <h2 className="text-xl font-semibold mt-6 mb-3">Use of Content</h2>
        <p className="mb-4">
          All content available on PlayGG, including but not limited to text,
          graphics, logos, images, videos, software, and other materials
          (collectively referred to as "Content"), is the property of PlayGG or
          its licensors and is protected by applicable copyright, trademark, and
          intellectual property laws.
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>
            Copy, reproduce, distribute, or create derivative works from the
            Content without prior written consent.
          </li>
          <li>
            Modify, translate, or reverse-engineer any part of the platform or
            its Content.
          </li>
          <li>
            Use the Content for unlawful purposes or in a manner that harms
            PlayGG’s reputation or infringes on the rights of others.
          </li>
        </ul>
        <h2 className="text-xl font-semibold mt-6 mb-3">
          Acceptable Terms of Use
        </h2>
        <h3 className="text-lg font-semibold mt-4">1. Eligibility</h3>
        <ul className="list-disc list-inside mb-4">
          <li>
            You must be at least 18 years old or have consent from a legal
            guardian.
          </li>
          <li>
            You are responsible for ensuring compliance with all applicable
            laws.
          </li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">2. User Account</h3>
        <ul className="list-disc list-inside mb-4">
          <li>You must maintain confidentiality of your login credentials.</li>
          <li>
            Providing false information may lead to account suspension or
            termination.
          </li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">3. Prohibited Activities</h3>
        <ul className="list-disc list-inside mb-4">
          <li>Violation of laws, regulations, or third-party rights.</li>
          <li>Fraudulent, illegal, or abusive activities.</li>
          <li>Submitting false, misleading, or offensive content.</li>
          <li>Uploading harmful code (viruses, malware, etc.).</li>
          <li>Exploiting tournaments through unfair practices.</li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">4. Intellectual Property</h3>
        <p className="mb-4">
          All intellectual property, including trademarks and code, belongs to
          PlayGG.
        </p>
        <h3 className="text-lg font-semibold mt-4">5. Community Guidelines</h3>
        <ul className="list-disc list-inside mb-4">
          <li>Be respectful in chats, forums, and tournaments.</li>
          <li>Avoid sharing personal or sensitive information.</li>
          <li>Report violations to our support team.</li>
        </ul>
        <h3 className="text-lg font-semibold mt-4">6. Service Availability</h3>
        <p className="mb-4">
          We strive for uninterrupted service but do not guarantee it will
          always be available, secure, or error-free.
        </p>
        <h3 className="text-lg font-semibold mt-4">7. Termination</h3>
        <p className="mb-4">
          PlayGG reserves the right to suspend or terminate accounts for any
          breach of terms.
        </p>
        <h3 className="text-lg font-semibold mt-4">
          8. Limitation of Liability
        </h3>
        <p className="mb-4">
          PlayGG is not liable for losses, damages, or disputes from platform
          usage.
        </p>
        <h3 className="text-lg font-semibold mt-4">
          9. Modifications to Terms
        </h3>
        <p className="mb-4">
          We may update terms at any time. Continued use of PlayGG signifies
          acceptance.
        </p>
        <h3 className="text-lg font-semibold mt-4">10. Contact Information</h3>
        <p className="mb-4">
          For inquiries, contact us at{" "}
          <a href="mailto:contact@playgg.in" className="text-blue-600">
            contact@playgg.in
          </a>
          .
        </p>
        <h2 className="text-xl font-semibold mt-6 mb-3">
          Payment Refund & Cashback Policy
        </h2>
        <ul className="list-disc list-inside mb-4">
          <li>Payments made through PlayGG are non-refundable.</li>
          <li>
            Any disputes regarding transactions will be reviewed on a basis and
            PlayGG reserves the right to issue refunds at its sole discretion in
            cases of unauthorized charges or technical errors.
          </li>
          <li>
            If the refund is approved, the amount will be automatically refunded
            to your original payment method within 7 business days.
          </li>
          <li>
            The cashback amount will be reflected in your app wallet within 24
            hours.
          </li>
        </ul>
        <h2 className="text-xl font-semibold mt-6 mb-3">User Responsibility</h2>
        <ul className="list-disc list-inside mb-4">
          <li>Maintain confidentiality of login credentials.</li>
          <li>
            Accessing the platform outside of designated regions is at your own
            risk.
          </li>
          <li>
            Users are responsible for their own internet and device costs.
          </li>
        </ul>
        <p className="mt-6">
          By accessing PlayGG, you agree to these Terms of Use.
        </p>
      </div>
    </>
  );
};

export default Terms;
